import { createContext, MouseEvent, ReactNode } from 'react';
import { UserForAppBar } from '../../../utils/userName';

export interface AccountMenuContextValues {
  user: UserForAppBar | undefined;
  /**
   * Whether the built-in app switcher trigger should render as an account menu item.
   * Set by `AppBarLayout` based on `appSwitcherPlacement` and the current layout width.
   */
  showAppSwitcherInAccountMenu?: boolean;
  /**
   * Icon for the built-in app switcher trigger, forwarded from `AppBarLayout`.
   */
  appSwitcherIcon?: ReactNode;
  /**
   * Opens the built-in app switcher drawer from within the account menu.
   */
  onOpenAppSwitcherFromAccountMenu?: (event: MouseEvent) => void;
}

export const AccountMenuContext = createContext<AccountMenuContextValues | undefined>(undefined);
